var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _rect8, _path3, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigGun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 6,
    height: 14,
    fill: "#79A401"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 6,
    height: 2,
    fill: "#569900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54043 7.07234C2.71359 6.66828 3.28641 6.66828 3.45957 7.07234L5.7013 12.303C5.8427 12.633 5.60069 13 5.24173 13H0.75827C0.399312 13 0.157297 12.633 0.298697 12.303L2.54043 7.07234Z",
    fill: "#76D200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 6,
    height: 2,
    fill: "#569900"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 6,
    height: 14,
    fill: "#79A401"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 6,
    height: 2,
    fill: "#569900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5404 7.07234C20.7136 6.66828 21.2864 6.66828 21.4596 7.07234L23.7013 12.303C23.8427 12.633 23.6007 13 23.2417 13H18.7583C18.3993 13 18.1573 12.633 18.2987 12.303L20.5404 7.07234Z",
    fill: "#76D200"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 6,
    height: 2,
    fill: "#569900"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 6,
    height: 14,
    fill: "#79A401"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 6,
    height: 2,
    fill: "#569900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5404 1.07234C11.7136 0.668283 12.2864 0.668282 12.4596 1.07234L14.7013 6.30304C14.8427 6.63297 14.6007 7 14.2417 7H9.75827C9.39931 7 9.1573 6.63297 9.2987 6.30304L11.5404 1.07234Z",
    fill: "#76D200"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 6,
    height: 2,
    fill: "#569900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGun);
export default __webpack_public_path__ + "static/media/bigGun.2239e953ac6f9e017790d4225ebbe050.svg";
export { ForwardRef as ReactComponent };